import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_slice_collections, use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { TABLE__empty } from '@/pages/_base/table/TABLE__empty';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { DTO__workspace_child_enity } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/dto_workspace_child_enity';
import { DTO__collection } from '@shared/dto/collection/DTO__collection';
import { useTranslation } from 'react-i18next';
import { WSSharedTableHeader } from '../_base/WSSharedTableHeader';
import { WSSharedTableRow } from '../_base/WSSharedTableRow';

export function WSSharedCollectionTable() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { collections_map } = use_slice_collections(['collections_map']);
  const { workspace_current } = use_slice_workspace(['workspace_current']);

  /*
   * RENDERS
   */

  function render_rows(collections: DTO__collection[]) {
    return collections.map((collection, index) => {
      return <WSSharedTableRow item={collection} key={`${collection._id}_${index}`} url={ENUM__page_type.BUILD_PATH_COLLECTIONS(collection._id)} />;
    });
  }

  function render_table(collections: DTO__collection[]) {
    collections = collections
      .filter(search => search.workspace_id == workspace_current._id)
      .filter(search => search.is_shared)
      .sort(DTO__workspace_child_enity.sort_by_sharing_started_at);

    let out = <></>;

    if (collections.is_empty()) {
      out = <TABLE__empty />;
    } else {
      out = <div className="flex flex-col justify-start items-center h-full w-full ">{render_rows(collections)}</div>;
    }

    return out;
  }

  /*
   * HTML
   */

  return (
    <div className="w-full h-full">
      <div
        className={`${md(
          'h-full w-full overflow-auto',
          ' pt-2 max-h-[25vh] ',
        )} mt-3  flex flex-col justify-center items-start  border-b border-component-border  text-page-foreground`}
      >
        <div className="text-xl">{t(i18n_page_settings_workspace.tabs.shared_entities.collections_component.title)}</div>
        <WSSharedTableHeader />

        {render_table(Array.from(collections_map.values()))}
      </div>
    </div>
  );
}
